"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_ERROR_MESSAGE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _notistack = require("notistack");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    spinner: {
      color: theme.palette.primary.dark,
      position: 'absolute',
      zIndex: 1
    }
  };
};

var DEFAULT_ERROR_MESSAGE = 'An error occurred';
exports.DEFAULT_ERROR_MESSAGE = DEFAULT_ERROR_MESSAGE;

var FeedbackButton = function FeedbackButton(props) {
  var children = props.children,
      classes = props.classes,
      disabled = props.disabled,
      upstreamOnClick = props.onClick,
      successMessage = props.successMessage,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? DEFAULT_ERROR_MESSAGE : _props$errorMessage,
      restOfProps = _objectWithoutProperties(props, ["children", "classes", "disabled", "onClick", "successMessage", "errorMessage"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isBusy = _useState2[0],
      setIsBusy = _useState2[1];

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var getSnackbarSuccessMessage = function getSnackbarSuccessMessage(result) {
    return typeof successMessage === 'function' ? successMessage(result) : successMessage;
  };

  var showSuccessNotification = function showSuccessNotification(result) {
    return enqueueSnackbar(getSnackbarSuccessMessage(result), {
      variant: 'success'
    });
  };

  var getSnackbarErrorMessage = function getSnackbarErrorMessage(err) {
    return typeof errorMessage === 'function' ? errorMessage(err) : errorMessage;
  };

  var showErrorNotification = function showErrorNotification(err) {
    return enqueueSnackbar(getSnackbarErrorMessage(err), {
      variant: 'error'
    });
  };

  var onClick = function onClick() {
    try {
      var retVal = upstreamOnClick.apply(void 0, arguments);

      if (retVal && retVal.finally) {
        setIsBusy(true);
        retVal.finally(function () {
          return setIsBusy(false);
        });
      }

      if (successMessage) {
        if (retVal && retVal.then) {
          retVal.then(showSuccessNotification);
        } else {
          showSuccessNotification(retVal);
        }
      }

      if (errorMessage && retVal && retVal.catch) retVal.catch(showErrorNotification);
      return retVal;
    } catch (err) {
      if (errorMessage) showErrorNotification(err);
    }
  };

  return _react.default.createElement(_core.Button, _extends({}, restOfProps, {
    onClick: upstreamOnClick && onClick,
    disabled: disabled || isBusy
  }), children, isBusy && _react.default.createElement(_core.CircularProgress, {
    size: 24,
    className: classes.spinner
  }));
};

var _default = (0, _styles.withStyles)(styles)(FeedbackButton);

exports.default = _default;